import React, { useEffect } from "react";
import { ProductDetailPageResult } from "./ProductDetailPageResult";
import { User } from "~/common/Store/models/User";
import ExpandedDescriptionTemplateDetailSection from "./Templates/ExpandedDescriptionTemplateDetailSection";
import StandardTemplateDetailSection from "./Templates/StandardTemplateDetailSection";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import getABFeatureFlag from "~/common/Featbit/getABFeatureFlag";
import updateVariationIds from "~/Gtm/updateVariationIds";
import { VariationIds } from "~/common/globals";

interface DescriptionSectionProps {
  isExpandedDescriptionTemplate: boolean;
  activeTemplate: ProductDetailPageResult;
  setExpandedDescriptionOffABTest?: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  user: User;
  mounted?: boolean;
}

const DescriptionSection = ({
  isExpandedDescriptionTemplate,
  activeTemplate,
  setExpandedDescriptionOffABTest,
  user,
  mounted,
}: DescriptionSectionProps) => {
  useEffect(() => {
    const setABVariationData = async (
      sessionId: string,
      emailAddress?: string,
    ) => {
      const result = await getABFeatureFlag(
        {
          featureFlagName: "pdp-xd-ab",
          defaultValue: "A",
          customProps: [{ key: "Page", value: window.location.pathname }],
        },
        { sessionId, emailAddress },
      );

      if (result.isError) {
        return;
      }

      const flag = result.value.stringValue;

      setExpandedDescriptionOffABTest?.(flag === "B");

      if (flag !== "C") {
        updateVariationIds([
          {
            featureName: VariationIds.ExpandedDescription_AB_Test,
            featureOption: flag,
          },
        ]);
      }
    };

    if (mounted && user.sessionId && isExpandedDescriptionTemplate) {
      setABVariationData(user.sessionId, user.emailAddress);
    }
  }, [
    mounted,
    isExpandedDescriptionTemplate,
    user.emailAddress,
    user.sessionId,
    setExpandedDescriptionOffABTest,
  ]);

  return (
    <section>
      {isExpandedDescriptionTemplate ? (
        <ExpandedDescriptionTemplateDetailSection
          activeTemplate={activeTemplate}
          user={user}
          mounted
        />
      ) : (
        <StandardTemplateDetailSection activeTemplate={activeTemplate} />
      )}
    </section>
  );
};

export default connectUserAndChat(DescriptionSection);
